"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flag = void 0;
const utils_1 = require("./utils");
const internalRoxFlag = utils_1.internalRox.Flag;
class Flag extends internalRoxFlag {
}
exports.Flag = Flag;
//# sourceMappingURL=flag.js.map